// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.readonly-input {
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/health-center/create-edit-health-center/create-edit-health-center.component.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;AACF","sourcesContent":[".readonly-input {\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
